import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CrudService } from "src/app/components/shared/cruds/crud.service";
import { UsuarioSimpleDto } from "src/app/models/dto/usuario-simple.dto";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class UsersService extends CrudService<UsuarioSimpleDto> {
  protected controller: string = "settings/usuarios/";

  public changePass(defa: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.http.post<any>(
      `${environment.serverUrl}api/${this.controller}/changePass`,
      defa,
      options
    );
  }
  public changePassOwn(defa: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.http.post<any>(
      `${environment.serverUrl}api/${this.controller}/changePassOwn`,
      defa,
      options
    );
  }
}
